import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function Products() {
  const categories = ['Todos', 'Panificados', 'Facturas', 'Tortas', 'Desayunos', 'Masas Dulces', 'Sandwiches', 'Cafetería'];
  const [activeCategory, setActiveCategory] = useState('Todos');
  const products = [{
    name: 'Pan Francés',
    category: 'Panificados',
    image: 'https://images.unsplash.com/photo-1549931319-a545dcf3bc73?w=400&q=80',
    description: 'Crujiente por fuera, suave por dentro'
  }, {
    name: 'Medialunas',
    category: 'Facturas',
    image: 'https://images.unsplash.com/photo-1555507036-ab1f4038808a?w=400&q=80',
    description: 'Manteca o grasa, recién horneadas'
  }, {
    name: 'Torta Rogel',
    category: 'Tortas',
    image: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=400&q=80',
    description: 'Capas de dulce de leche y merengue'
  }, {
    name: 'Desayuno Completo',
    category: 'Desayunos',
    image: 'https://images.unsplash.com/photo-1533777857889-4be7c70b33f7?w=400&q=80',
    description: 'Café, medialunas y jugo natural'
  }, {
    name: 'Alfajores Artesanales',
    category: 'Masas Dulces',
    image: 'https://cdn.magicpatterns.com/uploads/6M6wyeLi3JEVjMY1VBAHZ3/Hitube_K439iw6wCw_2026_05_13_00_44_33.jpg',
    description: 'Dulce de leche y coco'
  }, {
    name: 'Sandwich de Miga',
    category: 'Sandwiches',
    image: 'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=400&q=80',
    description: 'Variedad de sabores'
  }, {
    name: 'Café Especial',
    category: 'Cafetería',
    image: 'https://images.unsplash.com/photo-1511920170033-f8396924c348?w=400&q=80',
    description: 'Granos seleccionados'
  }, {
    name: 'Facturas Surtidas',
    category: 'Facturas',
    image: 'https://cdn.magicpatterns.com/uploads/4Cskxt53Pg8YsDLA4LK9aa/Hitube_VZNfeISRnI_2026_05_13_00_50_18.jpg',
    description: 'Variedad de dulces y saladas'
  }];
  const filteredProducts = activeCategory === 'Todos' ? products : products.filter(p => p.category === activeCategory);
  return <section id="productos" className="py-20 bg-white" data-id="element-141">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-143">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-secondary-brown mb-4" data-id="element-144">
            Nuestros Productos
          </h2>
          <p className="text-lg text-secondary-brown-light max-w-2xl mx-auto" data-id="element-145">
            Descubrí nuestra selección de productos artesanales, elaborados con
            pasión y los mejores ingredientes
          </p>
        </motion.div>

        <div className="flex justify-center mb-12" data-id="element-146">
          <div className="inline-flex flex-wrap justify-center gap-1 p-2 bg-secondary-cream/60 backdrop-blur-sm rounded-2xl border border-secondary-cream-dark/40" data-id="element-147">
            {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className="relative px-5 py-2.5 text-sm font-medium transition-colors duration-300 rounded-xl" data-id="element-148">
                {activeCategory === category && <motion.div layoutId="activeCategory" className="absolute inset-0 bg-white rounded-xl shadow-md border-b-2 border-primary-yellow" transition={{
              type: 'spring',
              stiffness: 400,
              damping: 30
            }} data-id="element-149" />}
                <span className={`relative z-10 ${activeCategory === category ? 'text-secondary-brown font-semibold' : 'text-secondary-brown-light hover:text-secondary-brown'}`} data-id="element-150">
                  {category}
                </span>
              </button>)}
          </div>
        </div>

        <motion.div layout className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-151">
          <AnimatePresence data-id="element-152">
            {filteredProducts.map((product, index) => <motion.div key={product.name} layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            delay: index * 0.05
          }} whileHover={{
            y: -8
          }} className="bg-white rounded-2xl shadow-lg overflow-hidden group cursor-pointer" data-id="element-153">
                <div className="relative h-64 overflow-hidden" data-id="element-154">
                  <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-155" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-156" />
                </div>
                <div className="p-6" data-id="element-157">
                  <h3 className="text-xl font-serif font-semibold text-secondary-brown mb-2" data-id="element-158">
                    {product.name}
                  </h3>
                  <p className="text-secondary-brown-light" data-id="element-159">
                    {product.description}
                  </p>
                </div>
              </motion.div>)}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>;
}